import styled from 'styled-components';

export const StyleGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 15px;
  grid-row-gap: 20px;
`;

export default StyleGrid;
